import { ElementDto, SceneTypeDto } from "@repo/api/overlays";
import { AbsoluteFill } from "remotion";
import { AssetMediaAsyncDto } from "@repo/api/asset-media";
import { ElementTiming } from "../../utils/timing.ts";
import { Element } from "./Element.tsx";

type Props = {
  elements: ElementDto[];
  elementTimings: Record<string, ElementTiming | null>;
  assetMedias: Record<string, AssetMediaAsyncDto>;
  sceneType: SceneTypeDto;
};

export default function ElementsLayer({
  elements,
  elementTimings,
  assetMedias,
  sceneType,
}: Props) {
  const reversedElements = [...elements].reverse();

  return (
    <AbsoluteFill>
      {reversedElements.map((element) => {
        const props = {
          element,
          elementTiming: elementTimings[element.externalId] ?? null,
          assetMedias,
          sceneType,
        };

        return <Element key={element.externalId} {...props} />;
      })}
    </AbsoluteFill>
  );
}
